import type { LegalDoc } from "../types";
import { LEGAL_COMPANY as C } from "../company";

export const workerConduct: LegalDoc = {
  slug: "worker-conduct",
  title: "Quy tắc dành cho Người tìm việc",
  metaTitle: "Quy tắc Người tìm việc",
  metaDescription:
    "Quy tắc dành cho Người tìm việc trên Chốt Ca: hồ sơ trung thực, kỷ luật phỏng vấn, quyền của bạn và cách nhận diện lừa đảo.",
  version: "2.0.0",
  effectiveDate: C.effectiveDate,
  intro:
    "Chốt Ca **miễn phí hoàn toàn** với người tìm việc và sẽ luôn như vậy. Bộ quy tắc dưới đây giúp bạn dùng nền tảng hiệu quả, kiểm soát được thông tin của mình và tránh các bẫy lừa đảo tuyển dụng phổ biến trong ngành F&B.",
  sections: [
    {
      title: "1. Quyền của bạn",
      body: "Trước khi nói tới nghĩa vụ, đây là những gì bạn luôn được bảo đảm:",
      items: [
        "**Bạn không bao giờ phải trả tiền cho Chốt Ca.** Không có gói trả phí, không có tính năng khoá sau tường phí, không có phí hồ sơ.",
        "**Bạn kiểm soát thông tin liên hệ của mình.** Xem mục 2 để biết chính xác khi nào quán thấy số điện thoại của bạn.",
        "**Bạn có quyền từ chối** bất kỳ lời mời phỏng vấn nào mà không cần nêu lý do, và việc từ chối không làm hồ sơ của bạn bị đánh giá thấp.",
        "**Bạn có quyền ẩn một quán cụ thể** để họ không thấy và không mời được bạn.",
        "**Bạn có quyền xoá toàn bộ dữ liệu của mình** bất cứ lúc nào — xem [Hướng dẫn xoá dữ liệu](/data-deletion).",
        "**Bạn không bao giờ phải nộp tiền cho quán** để được nhận việc. Không đặt cọc, không phí đồng phục, không phí đào tạo trước khi có hợp đồng lao động.",
      ],
    },
    {
      title: "2. Hiểu rõ khi nào quán thấy thông tin của bạn",
      body: "Đây là điều nhiều người dùng hiểu nhầm nhất. Hãy đọc kỹ trước khi bấm ứng tuyển.",
      items: [
        "**Khi bạn chủ động ứng tuyển một tin**: quán đó nhận ngay **toàn bộ hồ sơ, họ tên đầy đủ, số điện thoại và email** của bạn. Ngay lập tức, không có bước xác nhận thêm. Chỉ ứng tuyển vào tin bạn thật sự quan tâm.",
        "**Khi bạn bật chế độ Đang tìm việc**: hồ sơ của bạn vào kho ứng viên ở **dạng che**. Quán chỉ thấy tên viết tắt, ảnh, năm sinh, quận, kỹ năng và kinh nghiệm. Họ **không thấy** số điện thoại của bạn.",
        "**Khi có quán mời bạn phỏng vấn từ kho ứng viên**: thông tin của bạn **vẫn được che**. Số điện thoại chỉ mở khi **bạn bấm nhận lời mời và chọn khung giờ**.",
        "**Không trả lời lời mời là đủ.** Bạn từ chối hoặc để hết hạn 24 giờ thì quán đó không bao giờ thấy số của bạn.",
        "**Tắt chế độ Đang tìm việc** bất cứ lúc nào để rời khỏi kho ứng viên ngay lập tức.",
      ],
    },
    {
      title: "3. Hồ sơ trung thực",
      items: [
        "Khai đúng họ tên, năm sinh, khu vực đang ở và thông tin liên hệ của **chính bạn**.",
        "Liệt kê kinh nghiệm thật: tên quán, vị trí, thời gian, công việc đã làm. Dùng được cả tên quán đã đóng cửa.",
        "Không dùng ảnh, giấy tờ hoặc danh tính của người khác. Không tạo nhiều tài khoản.",
        "Ảnh đại diện nên là ảnh thật của bạn, rõ mặt. Đây là yếu tố khiến quán bấm vào hồ sơ của bạn nhiều nhất.",
        "Mức lương mong muốn nên sát mặt bằng khu vực. Đặt quá cao thì ít quán liên hệ.",
        "Chỉ điền các thông tin bạn thấy thoải mái khi chia sẻ. Các trường như chiều cao, cân nặng, hình xăm và ảnh toàn thân là **tuỳ chọn**, bạn bỏ trống được. Quán không được dùng các thông tin này để phân biệt đối xử, xem [Thoả thuận dành cho Nhà tuyển dụng](/employer-agreement) mục 4.",
      ],
    },
    {
      title: "4. Nếu bạn chưa đủ 18 tuổi",
      body: "Pháp luật lao động Việt Nam đặt ra giới hạn để bảo vệ bạn, không phải để làm khó bạn:",
      items: [
        "**Dưới 15 tuổi**: chưa được tạo hồ sơ tìm việc trên Chốt Ca.",
        "**Từ đủ 15 đến chưa đủ 18 tuổi**: bạn tạo hồ sơ và ứng tuyển được, nhưng **không được** nhận việc pha chế hoặc bán đồ uống có cồn, **không được** làm ở quán bar, vũ trường, karaoke, khách sạn, nhà nghỉ, cơ sở tắm hơi hay xoa bóp, và **không được** làm ca đêm từ 22:00 tới 06:00.",
        "Thời giờ làm việc của bạn **không quá 08 giờ mỗi ngày và 40 giờ mỗi tuần**.",
        "Khi đi làm, quán **phải có sự đồng ý của cha, mẹ hoặc người giám hộ** của bạn.",
        "Quán nào mời bạn làm những công việc bị cấm ở trên là đang vi phạm pháp luật. Hãy từ chối và báo cáo cho chúng tôi.",
      ],
    },
    {
      title: "5. Kỷ luật ứng tuyển và phỏng vấn",
      items: [
        "**Đọc kỹ tin** trước khi ứng tuyển: ca làm, lương, địa điểm có phù hợp với bạn không.",
        "Bạn có **24 giờ** để trả lời một lời mời phỏng vấn. Quá hạn, lời mời tự hết hiệu lực.",
        "Sau khi nhận lời mời, bạn có **30 phút** để đổi ý mà không bị tính là thất hẹn.",
        "Bạn giữ tối đa **5 lời mời đang chờ trả lời** cùng lúc. Trả lời bớt để nhận thêm lời mời mới.",
        "**Đến đúng giờ** khi đã chốt lịch phỏng vấn. Nếu bận đột xuất, gọi báo cho quán càng sớm càng tốt — họ đã sắp xếp thời gian cho bạn.",
        "**Không ứng tuyển hàng loạt** mọi tin trong khu vực. Chốt Ca giới hạn số đơn mỗi ngày và siết lại khi phát hiện hành vi bất thường.",
        "Nhận việc rồi nhưng đổi ý thì **báo cho quán trước ngày bắt đầu**, đừng im lặng.",
      ],
    },
    {
      title: "6. Cảnh giác lừa đảo tuyển dụng",
      body: "Bạn **KHÔNG** bao giờ phải trả tiền, đặt cọc hay nộp giấy tờ gốc trước khi ký hợp đồng lao động. Hãy dừng lại và báo cáo ngay nếu gặp các dấu hiệu sau:",
      items: [
        "Yêu cầu chuyển khoản, mua đồng phục, mua dụng cụ, đóng phí đào tạo hay phí giữ chỗ trước khi đi làm.",
        "Yêu cầu giữ bản gốc Căn cước công dân, bằng cấp hoặc giấy tờ tuỳ thân.",
        "Hứa lương cao bất thường so với mặt bằng, kiểu việc nhẹ lương cao.",
        "Mời đi làm việc ở tỉnh khác hoặc nước ngoài qua kênh không chính thức.",
        "Ép chuyển sang Telegram hoặc tài khoản cá nhân ngay từ đầu, trước cả khi phỏng vấn.",
        "Có dấu hiệu mời gọi quan hệ tình cảm hoặc tình dục dưới vỏ bọc tuyển dụng.",
        "Địa điểm phỏng vấn là nhà riêng, khách sạn hoặc nơi vắng vẻ thay vì cơ sở kinh doanh.",
        `**Ai đó tự xưng là nhân viên Chốt Ca** và hỏi mật khẩu hoặc mã OTP của bạn. Chốt Ca **không bao giờ** hỏi mật khẩu hay mã OTP, và **không bao giờ gửi tin nhắn SMS** — mọi mã xác thực của chúng tôi chỉ gửi qua email. Báo ngay tới ${C.abuseEmail}.`,
      ],
    },
    {
      title: "7. Tự bảo vệ khi đi phỏng vấn và khi nhận việc",
      items: [
        "**Nói cho người thân biết** bạn đi phỏng vấn ở đâu, giờ nào, đặc biệt với ca tối.",
        "Phỏng vấn tại **địa chỉ cơ sở kinh doanh** đã ghi trong lời mời. Địa chỉ đổi vào phút chót là dấu hiệu đáng ngờ.",
        "Đề nghị quán **ký hợp đồng lao động bằng văn bản** với công việc từ đủ 01 tháng trở lên, theo Điều 13 và Điều 14 Bộ luật Lao động 2019.",
        "Hỏi rõ mức lương, cách tính lương, ngày trả lương, thời gian thử việc và ca làm **trước khi nhận việc**.",
        "**Lưu lại tin nhắn thoả thuận** phòng khi có tranh chấp.",
        "Yêu cầu được tham gia bảo hiểm xã hội nếu bạn thuộc đối tượng theo quy định.",
        "Lương của bạn do quán trả trực tiếp. **Chốt Ca không giữ lương, không thu hộ, không chi hộ.** Bất kỳ ai nói lương của bạn đi qua Chốt Ca đều là lừa đảo.",
      ],
    },
    {
      title: "8. Khi đã đi làm",
      items: [
        "Tôn trọng nội quy của quán. Không quay phim, chụp ảnh khu vực nội bộ khi chưa được phép.",
        "Bảo mật công thức, thông tin khách hàng và số liệu kinh doanh của quán.",
        "Không chiếm đoạt tài sản, nguyên liệu hay dữ liệu của quán.",
        "Nếu bị đối xử không đúng thoả thuận, ưu tiên trao đổi trực tiếp với quán trước, và báo cho chúng tôi nếu không giải quyết được.",
      ],
    },
    {
      title: "9. Hành vi bị cấm",
      items: [
        "Tạo nhiều tài khoản, dùng danh tính hoặc giấy tờ của người khác.",
        "Bán, cho thuê hoặc chuyển nhượng tài khoản Chốt Ca.",
        "Đòi tiền hoặc lợi ích cá nhân từ quán ngoài khuôn khổ thoả thuận lao động hợp pháp.",
        "Thu thập thông tin liên hệ của các quán trên Nền tảng để bán hoặc phục vụ mục đích khác ngoài tìm việc.",
        "Quấy rối, đe doạ, xúc phạm nhân sự của quán hoặc người dùng khác.",
        "Báo cáo sai sự thật nhằm hạ uy tín một quán.",
        "Tham gia đường dây tuyển dụng đa cấp hoặc lừa đảo.",
      ],
    },
    {
      title: "10. Xử lý vi phạm",
      body: "Tuỳ mức độ, Chốt Ca có thể nhắc nhở, hạn chế số đơn ứng tuyển, tạm khoá hoặc chấm dứt tài khoản. Với vi phạm nghiêm trọng như dùng giấy tờ giả, lừa đảo hoặc quấy rối, chúng tôi chấm dứt tài khoản ngay và phối hợp với cơ quan chức năng khi cần. Bạn có quyền khiếu nại quyết định xử lý theo [Quy tắc cộng đồng](/community-guidelines).",
    },
  ],
  contact: {
    title: "11. Báo cáo và hỗ trợ",
    body: "Gặp tin lừa đảo, quán đòi tiền, hoặc hành vi quấy rối? Dùng nút Báo cáo ngay trên tin hoặc hồ sơ, hoặc gửi email kèm ảnh chụp màn hình và mã tin.",
    prefix: "Báo cáo lừa đảo và vi phạm: ",
    email: C.abuseEmail,
  },
};
